<template>
  <div>
    <!-- отключаем multi-sort если включен group-by (работает нестабильно из за server-items-length) -->
    <v-data-table
        :headers="settingsKey===undefined ? localHeaders : visibleHeaders"
        :items="items"
        :server-items-length="count"
        :options.sync="options"
        :footer-props="{'items-per-page-options': $tools.isDefined(disablePagination) ? [1000] : [100, 500, 1000, 5000]}"
        :items-per-page="$tools.isDefined(disablePagination) ? 1000 : 100"
        dense
        :height="height-(16*3)"
        :fixed-header="typeof height!=='undefined'"
        :multi-sort="!groupBy"
        :show-select="selectAll!==undefined"
        :class="(typeof tableClass==='undefined' ? '' : ' '+tableClass)"
        :sort-by="typeof sortBy !=='undefined' ? sortBy : null"
        ref="nTable"
        :group-by="typeof groupBy!==undefined ? groupBy : false"
        hide-default-footer
        item-key="_key"
    >
      <template v-slot:group.header="{ items, isOpen, toggle }">
        <template v-if="$scopedSlots.groupHeader">
          <slot
            name="groupHeader"
            :items="items"
            :isOpen="isOpen"
            :toggle="toggle"
            :headers="headers"
          />
        </template>

        <template v-else>
          <th :colspan="headers.length + (selectAll !== undefined && 1)" @click="toggle">
            <div class="d-flex align-center">
              <v-icon>
                {{ isOpen ? 'mdi-chevron-down' : 'mdi-chevron-right' }}
              </v-icon>

              <span class="text-subtitle-1 pl-3 font-weight-medium">
                <!-- получает название по переданной цепочке ключей, например service.serviceCat.name -->
                {{ groupBy.split('.').reduce((acc, part) => acc && acc[part], items[0]) }} 
              </span>
            </div>
          </th>
        </template>
      </template>
      <template v-slot:header.data-table-select>
        <v-checkbox
            v-if="selectAll!==undefined"
            :input-value="selectAll"
            @change="$emit('update:selectAll', !selectAll)"
            :indeterminate="selectIndeterminate"
            class="ma-0 pa-0" dense hide-details/>
      </template>
      <template v-slot:top="{ pagination, options, updateOptions }">
        <v-sheet rounded class="overflow-hidden position-relative full-width">
          <v-row no-gutters>
            <v-col>
              <v-toolbar dense elevation="0" color="transparent" max-height="48px">
                <v-toolbar-title v-if="typeof name!=='undefined'" class="body-2 font-weight-medium">
                  {{ name }}
                </v-toolbar-title>
                <v-spacer/>
                <div class="mr-n2">
                  <v-row no-gutters align="center">
                    <v-col cols="auto">
                      <slot name="barActions"/>
                    </v-col>
                    <v-col cols="auto">
                      <tooltip bottom>
                        <v-btn @click="load(true)" width="36" height="36" icon :disabled="loading" class="ml-2">
                          <v-icon size="18">
                            {{$tools.isDefined(autoUpdate) ? 'mdi-refresh-auto' : 'mdi-refresh'}}
                          </v-icon>
                        </v-btn>
                        <template v-slot:content>
                          <div v-if="$tools.isDefined(autoUpdate)">
                            Обновить<br/>
                            Автоматическое обновление каждые<br/>15 секунд уже включено
                          </div>
                          <div v-else>
                            Обновить
                          </div>
                        </template>
                      </tooltip>
                    </v-col>
                    <v-col cols="auto">
                      <v-menu v-model="downloadAllState.modal" offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                              v-bind="attrs" v-on="on"
                              :disabled="loading"
                              width="36" height="36"
                              small icon class="ml-2"
                          >
                            <v-icon size="18">mdi-download</v-icon>
                          </v-btn>
                        </template>
                        <v-sheet class="ma-4" width="240" style="margin-left:-100px">
                          <div v-if="downloadAllState.loading" class="body-2 mb-4">
                            <div class="mb-2">Не покидайте страницу до момента полного скачивания</div>
                            <v-row class="caption">
                              <v-col>Скачивание</v-col>
                              <v-col cols="auto">{{downloadAllState.data1.itemsLength}} / {{downloadAllState.data1.itemsCount}}</v-col>
                            </v-row>
                            <v-progress-linear
                                :indeterminate="downloadAllState.data1.itemsLength===0"
                                :value="(downloadAllState.data1.itemsLength/downloadAllState.data1.itemsCount)*100"
                                rounded class="mb-4"
                            />
                            <v-btn @click.stop="downloadAllState.data = false" depressed small block>Отмена</v-btn>
                          </div>
                          <div v-else-if="downloadAllState.success" class="body-2 mb-4">
                            <div class="text-center">
                              <div class="mb-2"><v-icon color="success">mdi-check-circle</v-icon></div>
                              <div>Успешно скачано</div>
                            </div>
                          </div>
                          <v-row v-else no-gutters>
                            <v-col cols="12" class="body-2 mb-4">
                              Выберите c каких страниц вы хотите скачать данные
                            </v-col>
                            <v-col class="mr-2">
                              <v-btn @click.stop="$tools.download($refs.nTable,name);downloadAllState.stateSuccess()" depressed small block>Эта страница</v-btn>
                            </v-col>
                            <v-col class="text-right">
                              <v-btn @click.stop="loadAllForDownload()" depressed small block>Все</v-btn>
                            </v-col>
                          </v-row>
                        </v-sheet>
                      </v-menu>
                    </v-col>
                    <v-col v-if="$tools.isDefined(disablePagination)" cols="auto">
                      <tooltip>
                        <v-chip color="grey lighten-3 mx-1">
                          <v-icon class="mr-2" color="red" small>mdi-alert</v-icon>
                          <div class="caption black--text">Список ограничен</div>
                        </v-chip>
                        <template v-slot:content>
                          <div>Ограничено до 1000 записей.</div>
                          <div>Для получения более точных результатов воспользуйтесь фильтрами</div>
                        </template>
                      </tooltip>
                    </v-col>
                    <v-col cols="auto">
                      <template v-if="settingsKey!==undefined">
                        <tooltip right>
                          <v-btn
                              color="grey"
                              class="ml-2"
                              text
                              @click="tableSettingsOpen=true"
                          >
                            <v-icon small>mdi-cog-outline</v-icon>
                          </v-btn>
                          <template v-slot:content>
                            Настройки
                          </template>
                        </tooltip>

                        <dialog-editor
                            :item.sync="tableSettingsOpen"
                            name="Настройки таблицы"
                            width="800"
                            submitText="Сохранить"
                            @submit="saveTableSettings();tableSettingsOpen=null"
                            content-padding-remove
                        >
                          <template v-slot:footerActions>
                            <v-btn @click="localHeaders = localHeadersDefault" color="primary" text>
                              Сбросить настройки
                            </v-btn>
                          </template>
                          <v-simple-table class="pa-0" dense>
                            <template v-slot:default>
                              <thead>
                              <tr>
                                <th>Название</th>
                                <th>Показать</th>
                                <th>Сортировка</th>
                              </tr>
                              </thead>
                              <tbody>
                              <tr
                                  v-for="(item, index) in headers"
                                  :key="'setting'+index"
                                  :style="settingsKey!==undefined&&item.isSelected&&{background:'#E8F5E9'}"
                              >
                                <td class="py-1">
                                  {{ item.text }}
                                </td>
                                <td class="py-1">
                                  <v-checkbox
                                      v-model="item.visible"
                                      color="primary"
                                      hide-details
                                      class="pa-0 mt-0"
                                  ></v-checkbox>
                                </td>
                                <td class="py-1">
                                  <v-btn text @click="moveColumnUp(item.text)" class="px-1">
                                    <v-icon small color="green">mdi-arrow-up-thick</v-icon>
                                  </v-btn>
                                  <v-btn text @click="moveColumnDown(item.text)" class="px-1">
                                    <v-icon small color="orange">mdi-arrow-down-thick</v-icon>
                                  </v-btn>
                                </td>
                              </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </dialog-editor>
                      </template>
                    </v-col>
                  </v-row>
                </div>
              </v-toolbar>
            </v-col>
            <v-col v-if="!$tools.isDefined(disablePagination)" cols="auto">
              <v-data-footer
                  :pagination="pagination"
                  :options="options"
                  @update:options="updateOptions"
                  :itemsPerPageOptions="[100, 500, 1000, 5000]"
                  items-per-page-text="$vuetify.dataTable.itemsPerPageText"
                  class="ml-0 nTableNav"
              />
            </v-col>
          </v-row>
          <v-progress-linear v-if="loading" indeterminate class="position-absolute" style="top:0"/>
        </v-sheet>
      </template>
      <template v-slot:item="{ item }">
        <slot name="item" v-bind:item="item" v-bind:items="items" v-bind:headers="headers"/>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import Tooltip from "@/componentsV2/base/Tooltip.vue";
import DialogEditor from "@/componentsV2/base/DialogEditor.vue";
import Stater from "@/plugins/stater";
import mounted from "@/mixins/mounted";

export default {
  props: [
    'name',
    'height',
    'headers',
    'selectAll',
    'selectIndeterminate',
    'tableClass',
    'genRequestBuilder',
    'sortBy',
    'groupBy',
    'settingsKey',
    'tableOptions',
    'disablePagination',
    'autoUpdate'
  ],
  mixins:[mounted],
  components: {
    Tooltip,
    DialogEditor
  },
  data: () => ({
    localHeaders: [],
    localHeadersDefault: [],
    options: {},
    items: [],
    count: 0,
    loading: false,
    requestId: 0,
    abortController: null,
    tableSettingsOpen: false,
    key: null,
    updateTimerId: null,
    downloadAllState: new Stater(),
    //observer: null,
  }),
  mounted() {
    this.localHeaders = this.headers;
    this.localHeadersDefault = this.headers

    if (this.settingsKey !== undefined) {//настройки из localStorage
      const tableSettings = localStorage.getItem(this.settingsKey);
      if (localStorage[this.settingsKey] !== undefined && tableSettings !== null)
        this.localHeaders = JSON.parse(tableSettings);
    }

    // если переданы опции
    this.$nextTick(() => {
      if (this.tableOptions !== undefined && this.tableOptions !== null)
        this.options = this.tableOptions
    });
    this.load(true);

    if (this.$tools.isDefined(this.autoUpdate)) {
      this.timerId = setInterval(() => {
        this.$tools.pageVisibleCallback(() => {
          this.load();
        }, () => {
          this.$store.commit('alertWarning', 'Данные могли устареть. Обновите страницу или подождите 15 сек.');
        })
      }, 15000);
    }
  },
  beforeDestroy() {
    if (this.timerId !== null)
      clearInterval(this.timerId)
    if (this.abortController !== null)
      this.abortController.abort()
  },
  watch: {
    options: {
      handler() {
        this.load(true)

        this.$nextTick(() => {
          if (this.tableOptions !== undefined)
            this.$emit('update:tableOptions', this.options)
        });
      },
    },
    tableOptions(v) {
      // при очистке фильтров сбрасываем sort и page
      if (this.tableOptions !== undefined && v === null)
        this.resetSortAndPage()
    },
    groupBy(v) {
      if (v !== undefined)
        this.$nextTick(() => {
          this.collapseAllGroups();
        });
    },
    headers() {
      this.localHeaders = this.headers;
    },
    localHeaders: {
      handler() {
        this.$emit('update:headers', this.localHeaders)
      },
      deep: true,
    },
    'downloadAllState.modal'(v2,v1){
      if(v1 && !v2 && this.downloadAllState.success)
        this.$tools.debounce(()=>this.downloadAllState.stateInit(), 500, 'download')
    }
  },
  computed: {
    visibleHeaders() {
      return this.localHeaders.filter(h => h.visible);
    }
  },
  methods: {
    resetSortAndPage() {
      this.options.page = 1
      this.options.sortBy = []
      this.options.sortDesc = []
    },
    clear() {
      this.items = [];
    },
    load(fast = false) {
      this.$tools.debounce(() => {
        if (this.abortController !== null)
          this.abortController.abort()
        this.abortController = new AbortController()
        const requestId = ++this.requestId
        this.loading = true

        let sorts = [];
        this.options.sortBy.forEach((v, k) => {
          sorts.push({
            field: v,
            isAsc: this.options.sortDesc[k]
          });
        });

        let requestBuilder = null;
        if (this.$tools.isDefined(this.disablePagination)) {
          requestBuilder = this.genRequestBuilder(
              null,
              null,
              sorts
          )
        } else {
          requestBuilder = this.genRequestBuilder(
              this.options.page,
              this.options.itemsPerPage,
              sorts
          )
          //sync options
          this.options.page = requestBuilder._page
          this.options.itemsPerPage = requestBuilder._onPage
        }

        requestBuilder.addStateCallback((v) => {
          if (requestId !== this.requestId)
            return

          this.isError = v.error;
          this.errorMessage = v.errorMessage;

          if (v.loading) {
            this.loading = true
            return
          }

          this.loading = false

          if (v.success) {
            //this.observerSet();

            v.items.forEach(item => {
              item._key = item.id;
            });
            this.items = v.items;
            this.count = v.count;

            //return to the first page if items is empty and it isn't first page
            if (v.items.length === 0 && this.options.page > 1)
              this.options.page = 1;
          }
        })

        requestBuilder.request(null, (e) => {
          if (requestId !== this.requestId)
            return
          this.$store.commit('alertError', e);
        }, this.abortController.signal)

      }, fast ? 100 : 1000, 'nTableView')
    },
    loadAllForDownload(){
      let page = 1;
      let itemsOnPage = this.items;
      this.downloadAllState.data = true;
      this.downloadAllState.data1 = {itemsLength:0,itemsCount:0};
      this.downloadAllState.stateLoading();
      let data = this.$tools.downloadTableParserHeader(this.$refs.nTable);

      let next = ()=>{
        this.genRequestBuilder(page++, 100, [])
            .request(d=>{
              if(d.items.length>0){
                if(this.downloadAllState.data && this.mounted){
                  this.downloadAllState.data1.itemsLength += d.items.length;
                  this.downloadAllState.data1.itemsCount = d.count;

                  this.items = d.items;
                  this.$nextTick(()=>{
                    data += this.$tools.downloadTableParserItems(this.$refs.nTable)
                    this.items = itemsOnPage
                  })
                  next();
                } else {
                  this.downloadAllState.data1 = {itemsLength:0,itemsCount:0};
                  this.downloadAllState.stateInit();
                }
              } else {
                this.$tools.downloadAction(data, this.name);
                this.downloadAllState.stateSuccess();
              }
            }, ()=>{
              this.downloadAllState.stateInit();
            })
      }
      next();
    },
    collapseAllGroups() {
      const table = this.$refs.nTable;
      if (table && table.openCache) {
        Object.keys(table.openCache).forEach((group) => {
          this.$set(table.openCache, group, false);
        });
      }
    },
    moveColumnUp(selectedColumn) {
      const index = this.localHeaders.findIndex(h => h.text === selectedColumn);
      if (index <= 0) return; // Если элемент первый или не найден - выходим

      // функционал выделения строки с которой взаимодействуем
      this.localHeaders.forEach(header => {
        header.isSelected = false;
      });
      this.localHeaders[index].isSelected = true;

      const newHeaders = [...this.localHeaders];
      [newHeaders[index - 1], newHeaders[index]] = [newHeaders[index], newHeaders[index - 1]];
      this.localHeaders = newHeaders;
    },
    moveColumnDown(selectedColumn) {
      const index = this.localHeaders.findIndex(h => h.text === selectedColumn);

      if (index === -1 || index >= this.localHeaders.length - 1) return; // Если элемент последний или не найден

      // функционал выделения строки с которой взаимодействуем
      this.localHeaders.forEach(header => {
        header.isSelected = false;
      });
      this.localHeaders[index].isSelected = true;

      const newHeaders = [...this.localHeaders];
      [newHeaders[index], newHeaders[index + 1]] = [newHeaders[index + 1], newHeaders[index]];
      this.localHeaders = newHeaders;
    },
    saveTableSettings() {
      this.localHeaders.forEach(header => {
        delete header.isSelected;
      }); // очищаем от isSelected
      localStorage.setItem(this.settingsKey, JSON.stringify(this.localHeaders));
    },
    /*
    observerSet() {
      this.$nextTick(() => {
        if (this.observer !== null)
          this.observer.disconnect()

        let els = this.$refs.nTable.$el.querySelectorAll('.v-data-table__wrapper tbody tr');
        if (els.length === 0)
          return;

        this.observer = new IntersectionObserver(entries => {
          entries
              .filter(v => v.isIntersecting)
              .forEach(v => {
                console.log(v.target);
              })
        }, {threshold: 0.1})

        els.forEach(v => this.observer.observe(v))
      });
    },
     */
  }
}
</script>
